import { Controller } from "@hotwired/stimulus"

// Simple controller for adding/removing dynamic form rows.
// Usage:
//   <div data-controller="dynamic-rows">
//     <div data-dynamic-rows-target="container">
//       <div data-dynamic-rows-target="row">...</div>
//     </div>
//     <template data-dynamic-rows-target="template">
//       <div data-dynamic-rows-target="row">...</div>
//     </template>
//     <button data-action="click->dynamic-rows#add">Add</button>
//   </div>
export default class extends Controller {
  static targets = ["container", "template", "row"]

  add(e) {
    e.preventDefault()
    const content = this.templateTarget.innerHTML
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(e) {
    e.preventDefault()
    const row = e.target.closest("[data-dynamic-rows-target='row']")
    if (row) row.remove()
  }
}
